var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-3 flex-grow-0 flex-shrink-1",staticStyle:{"display":"inline-block"}},[_c('v-btn',{attrs:{"color":"red white--text","x-small":"","fab":"","loading":_vm.loading},on:{"click":_vm.prev}},[_c('v-icon',[_vm._v("undo")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }